<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('New warehouse') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/admin/warehouses">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="saveWarehouse">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Warehouse details') }}
              </h3>
              <p class="form-description-text">{{ $t('This information will be displayed publicly') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="name">{{ $t('Name') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Name')" class="form-input" id="name" required v-model="warehouse.name" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="max_volume">{{ $t('Max volume') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Max volume')" class="form-input" id="max_volume" required type="number" v-model="warehouse.max_volume" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="location">{{ $t('Location') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Location')" class="form-input" id="location" required v-model="warehouse.location" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <router-link class="btn btn-app mr-4" to="/admin/warehouses">{{ $t('Cancel') }}</router-link>
              <button class="btn btn-green" type="submit">
                {{ $t('Save') }}
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('Create warehouse'),
    };
  },
  data() {
    return {
      loading: false,
      warehouse: {
        name: null,
        location: null,
        max_volume: null,
      },
    };
  },

  methods: {
    saveWarehouse() {
      this.loading = true;
      axios
        .post(route('warehouses.store'), this.warehouse)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push(`/admin/warehouses/${response.data.warehouse.id}/edit`);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
